import { ReactNode } from "react";
import cx from "classnames";

import { useTransition } from "common/hooks";
import { stopPropagation } from "common/utils";

import styles from "../../styles/Lightbox.module.less";

type LightboxProps = {
  children: ReactNode;
  onClose: () => void;
};

const Lightbox = ({ onClose, children }: LightboxProps) => {
  const isVisible = true; // If this component is mounted, it is visible
  const { transitionState, durationStyle } = useTransition(isVisible);

  return (
    <div
      className={`${styles.container} ${styles[`transition-${transitionState}`]}`}
      style={{ transitionDuration: durationStyle }}
      role="presentation"
      onClick={onClose}
    >
      <div
        className={cx(styles.modal, styles[`transition-${transitionState}`])}
        style={{ transitionDuration: durationStyle }}
        role="presentation"
        onMouseDown={stopPropagation}
        onClick={stopPropagation}
      >
        {children}
      </div>
    </div>
  );
};

export default Lightbox;
